import { HelpCircle } from 'lucide-react';
import type { ReactNode } from 'react';

import { SimpleTooltip } from '@/components/tooltips/simple-tooltip';

type FieldLabelWithHintProps = {
  htmlFor?: string;
  label: ReactNode;
  hint: ReactNode;
};

export function FieldLabelWithHint({
  htmlFor,
  label,
  hint,
}: FieldLabelWithHintProps) {
  return (
    <div className='flex items-center gap-1.5'>
      <label htmlFor={htmlFor} className='text-sm font-medium'>
        {label}
      </label>
      <SimpleTooltip title={hint} delayDuration={200}>
        <button
          type='button'
          className='inline-flex text-muted-foreground hover:text-foreground'
          aria-label='More information'
        >
          <HelpCircle className='size-3.5' />
        </button>
      </SimpleTooltip>
    </div>
  );
}
